
/**
 * 使用webworker作为运行环境需要支持proxy
 */
export function isSupportWorkerAndProxy() {
  return !!window.Proxy;
}

/**
 * 建立ws连接
 */
export function initWebSocket() {
  return new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();
    request.onreadystatechange = () => {
      if (request.readyState === 4) {
        const res = JSON.parse(request.response);
        const { serverUrl } = res.data;
        const ws = new WebSocket(serverUrl);
        ws.onopen = () => {
          resolve(ws);
        };
        ws.onerror = reject;
      }
    };
    request.onerror = reject;
    request.open('get', 'https://ivapi-sandbox.video.qq.com/compr/run');
    request.send();
  });
}
